module.exports = __webpack_public_path__ + "static/media/monthly-payment-bck.815d78e6.png";